import { Notifier } from '@airbrake/browser';

window.onerror = (msg, url, line, col, error) => {
  const airbrake = new Notifier({
    projectId: 103320,
    projectKey: '22c6c5c1dd4b39a03e760db2bb8d63e6793c22b2',
  });

  let err = !line ? '' : '\nline: ' + line;
  err += !col ? '' : '\ncolumn: ' + col;
  err += !error ? '' : '\nerror: ' + error;
  err += !error || !error.stack ? '' : '\nstacktrace:\n ' + error.stack;

  // send through to airpbrake if we're in production
  if (process.env.NODE_ENV === 'production') {
    airbrake.notify({
      error: err,
      context: { component: 'Damstra Form Wizard (JavaScript)' },
    });
    window.newrelic.noticeError(err, {
      component: 'Damstra Form Wizard (JavaScript)',
    });
  } else if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    console.log(err);
  }
};
